var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lf-simple-grid-field" },
    [
      _setup.gridConfiguration
        ? _c(_setup.Grid, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.listItems,
              toolbarOptions: _setup.toolbarOptions,
              toolbarClick: _setup.onToolbarClick,
              contextMenuItems: _setup.contextMenuItems,
              commandClick: _setup.onCommandClick,
              allowPaging: _vm.allowPaging,
            },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
      _c(_setup.PromptDialog, {
        attrs: {
          title: _setup.modalTitleParsed,
          isOpened: _setup.openedPrompt,
          context: _setup.context,
          formSchema: _setup.formSchema,
          formFieldValues: _setup.formData,
          width: _vm.promptWidth,
        },
        on: { "execute-action": _setup.onExecuteAction },
        scopedSlots: _vm._u(
          [
            _setup.slots.prepend
              ? {
                  key: "prepend",
                  fn: function () {
                    return [_vm._t("prepend")]
                  },
                  proxy: true,
                }
              : _setup.isBankAccountContext && _setup.hasExistingAccounts
              ? {
                  key: "prepend",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "static-grid-alert-container" },
                        [
                          _c(_setup.StaticAlertComponent, {
                            staticClass: "static-alert",
                            attrs: { alert: _setup.alertData },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }